import {FloatLayout} from '../components/float-layout';
import {Layout} from '../components/layout/layout';
import * as _ from 'lodash-es';
import {nanoid} from 'nanoid';

export class Tab {
    public static getNewTabId(): string {
        return nanoid();
    }
    public hasBeenJustAdded: boolean;

    constructor(
        public id: string,
        public name: string,
        public layout: Layout,
        public floatLayout: FloatLayout,
        options?: {hasBeenJustAdded: boolean}
    ) {
      if (options) {
        _.assign(this, options);
      }

      this.id = id || Tab.getNewTabId();
    }
}
